import { Link } from "react-router-dom";
import styled from "styled-components";

export const ContainerPaso = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0; /* Necesario para que flex funcione con scroll */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
`;

export const TopContainerPASO = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const Button = styled(Link)`
  font-size: 18px;
  margin: 10px;
  color: var(--color-black);
  text-decoration: none;
  font-weight: 500;
`;

export const BodyContainerPASO = styled.div`
  flex: 1;
  min-height: 0; /* Necesario para que flex:1 funcione con scroll */
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  position: relative;
  z-index: 5; /* Menor que el ::after (10) para que el contenido pase por debajo */

  /* ========== MOBILE WEB (navegador) ========== */
  ${(props) =>
    !props.$isNative &&
    `
    /* SCROLL VISIBLE para mobile web */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    
    /* Scrollbar visible en mobile web */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
  `}

  /* ========== APP NATIVA ========== */
  ${(props) =>
    props.$isNative &&
    `
    overflow-y: auto;
    
    /* Scrollbar oculta en app nativa */
    &::-webkit-scrollbar {
      width: 0;
      display: none;
    }
  `}
  
  .logo-dim {
    ${({ $hideLogo }) =>
      $hideLogo
        ? "display: none;"
        : `
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: -2;
          `}
  }
`;
export const HeaderBar = styled.div`
  position: relative;
  z-index: 20; /* Por encima de la curva y el contenido */
  width: 100%;
  height: 95px;
  min-height: 95px;
  margin: 0;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);
  flex-shrink: 0; /* No se encoge en flex containers */
  padding: 8px 15px;

  .title {
    text-transform: uppercase;
    margin-bottom: 8px;
  }

  /* Si no hay subtitle, el h1 es el último hijo y no necesita margin-bottom */
  h1.title:last-child {
    margin-bottom: 0;
  }

  p {
    width: 70%;
    text-align: center;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }

  .container-ellipse {
    width: 100%;
    height: max-content;
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  .arrow {
    font-size: 40px;
    position: absolute;
    left: 0;
    padding-left: 10px;
    cursor: pointer;
  }

  /* Ajustes para pantallas pequeñas */
  @media (max-height: 700px) {
    height: 85px;
    min-height: 85px;
    padding: 6px 12px;

    .title {
      margin-bottom: 6px;
    }
  }

  @media (max-height: 600px) {
    height: 75px;
    min-height: 75px;
    padding: 5px 10px;

    .title {
      margin-bottom: 4px;
    }

    p {
      font-size: 14px;
    }
  }

  @media (max-height: 550px) {
    height: 65px;
    min-height: 65px;
    padding: 4px 10px;

    .arrow {
      font-size: 30px;
    }
  }

  ${({ circle }) =>
    circle === 1
      ? `
    ::after {
        content: "";
        position: absolute;
        width: 100%;
        left: 0;
        height: 20px;
        bottom: -17px;
        border-radius: 0 0 50% 50% / 0 0 100% 100%;
        background-color: var(--color-latex10);
    }
    `
      : "border-bottom: 4px solid var(--color-primary); min-height: 70px; height: auto;"}
`;
